const images = {
  logo: require("../../assets/images/logo.jpg"),
};
export default images;
